import React from 'react';

interface Props {
}

interface State {
    error? : Error
}

export default class ErrorBoundary extends React.Component<Props,State> {
    static getDerivedStateFromError(error:Error) {
        // Update state so the next render will show the fallback UI.
        return { error };
    }
    constructor( props:Props ) {
        super(props);
        this.state = {
        };
    }
    render() {
        if( this.state.error )
            return <p className="text-center"><h1>{this.state.error?.message}</h1></p>;
        return this.props.children;
    }
}
